import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, HostListener, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';
import * as uuid from "uuid";
import * as FileSaver from 'file-saver';
import { FileService } from '../../services/file.service';

@Component({
  selector: 'mapfre-auditlib-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {

  @Input()
  label

  @Input()
  placeholder

  @Input()
  entityType

  @Input()
  entityId

  @Input()
  contentType = 'application/octet-stream';

  @Input()
  showComment: boolean = false;

  @Input()
  readonly;

  @Input()
  allowDelete = true;

  _form: UntypedFormControl;
  @Input()
  get form() {
    return this._form
  }
  set form(value) {
    if (value) {
      this._form = value;
      this.formChange.emit(this._form);
    }
  }
  @Output()
  formChange = new EventEmitter();

  @Input() icon;

  _model;
  @Input()
  get model() {
    return this._model
  }
  set model(value) {
    this._model = value;
    this.modelChange.emit(this._model);
  }

  @Output()
  modelChange = new EventEmitter();

  @Input()
  buttonIcon;
  @Output()
  buttonClicked = new EventEmitter();

  @Input()
  multiple: any = false;

  get files() {
    if (_.get(this.form, 'value')) {
      return this.multiple ? this.form.value : [this.form.value];
    } else {
      return [];
    }

  }

  @ViewChild("inputFile", { static: false })
  inputFileRef: any;

  @Output()
  downloadClicked = new EventEmitter();

  @Output()
  deleteClicked = new EventEmitter();

  constructor(private fileService: FileService) { }

  ngOnInit() {
  }

  @HostListener('keydown.enter', ['$event'])
  onButtonClicked() {
    this.buttonClicked.emit();
    this.form.markAsTouched();
  }

  onSelectFileClick() {
    this.form.markAsTouched();
    this.inputFileRef.nativeElement.click();
  }

  onInputChange(event) {
    if (event.target.files && event.target.files.length && event.target.files[0]) {
      let file = this.multiple ? event.target.files : event.target.files[0]
      this.form.setValue(this.multiple ? _.concat(this.form.value === null ? [] : this.form.value, ...file) : file);
    }
  }

  onDeleteClick(file) {
    let files = _.cloneDeep(this.form.value);
    _.remove(files, (f) => _.isEqual(f, file));
    this.form.setValue(this.multiple && files.length ? files : null);
  }

  onDownloadClick(file) {
    if (file instanceof File) { return; }
    if (file && typeof file === 'object' && file.txtNam) {
      const contentType = file.typDcm || this.contentType;
      this.fileService.downloadSpecial(file.txtNam, file.idtSqn, this.entityType, this.entityId, contentType).subscribe((res: any) => {
        let f = new File([res], file.txtNam, { type: contentType });
        FileSaver.saveAs(f);
      });
    } else {
      let filename = file;
      let key = `${uuid.v4()}/${filename}`;
      this.fileService.download(key, this.entityType, this.entityId, this.contentType).subscribe((res: any) => {
        let f = new File([res], filename, { type: this.contentType });
        FileSaver.saveAs(f);
      });
    }
  }


  getIcon(name) {
    name = _.lowerCase(name);

    if (_.includes(name, 'xls')) {
      return 'icon-24-px-doc-excel green-excel';
    }

    if (_.includes(name, 'pdf')) {
      return 'icon-24-px-doc-pdf red-pdf';
    }

    if (_.includes(name, 'ppt')) {
      return 'icon-24-px-doc-ppt orange-ppt';
    }

    if (_.includes(name, 'doc')) {
      return 'icon-24-px-doc-word blue-doc';
    }

    return 'icon-24-px-comunicacion';

  }


}
